import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import routeConfig from './routeConfig';

export default function Breadcrumbs() {
  const location = useLocation();
  const { t } = useTranslation();
  const currentPath = location.pathname;
  const currentRoute = routeConfig[currentPath];

  if (!currentRoute) return null;

  // Build breadcrumb chain
  const crumbs = [];
  let path = currentPath;
  while (path && routeConfig[path]) {
    crumbs.unshift({ path, label: t(routeConfig[path].labelKey) });
    path = routeConfig[path].parent || null;
  }

  if (crumbs.length <= 1) return null;

  return (
    <nav className="Breadcrumbs">
      {crumbs.map((crumb, index) => (
        <span key={crumb.path} className="Breadcrumbs__item">
          {index > 0 && <span className="Breadcrumbs__separator">/</span>}
          {index < crumbs.length - 1 ? (
            <Link to={crumb.path} className="Breadcrumbs__link">{crumb.label}</Link>
          ) : (
            <span className="Breadcrumbs__current">{crumb.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
